export enum AuthErrorCode {
  MissingOrInvalidDeviceId = 'AUTH_MISSING_OR_INVALID_DEVICE_ID',
  SuperAdmin2faNotEnabled = 'AUTH_SUPERADMIN_2FA_NOT_ENABLED',
}
